export const BILL_TYPES = {
  BILL_FROM: 'BILL_FROM',
  BILL_TO: 'BILL_TO'
};
